var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { ManufacturersClient, ModelsClient, LookupsClient, CompaniesClient, ManufacturerModel, GetModelListPaginatedQuery, PaginatedEnumerableOfModel, SortDescription, SortDirection, ManufacturerTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import RouteNames from "@/app/router/routes";
import Sorter from "@/common/utils/sorter";
import "@/app/component-hooks";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const manufacturersClient = new ManufacturersClient(window.apiUrl);
const modelsClient = new ModelsClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
const companiesClient = new CompaniesClient(window.apiUrl);
let ManufacturerVue = class ManufacturerVue extends Vue {
    constructor() {
        super(...arguments);
        this.companyId = 0;
        this.manufacturerId = 0;
        this.preselectedManufacturerTypeId = null;
        this.loaded = false;
        this.working = false;
        this.workingModels = false;
        this.attemptedSave = false;
        this.currencyCode = '';
        this.msg = new Alert();
        this.manufacturer = new ManufacturerModel();
        this.manufacturerTypes = [];
        this.componentTypes = [];
        // Models
        this.modelsSorter = new Sorter(new SortDescription({
            fieldName: "ModelName",
            direction: SortDirection.Ascending
        }));
        this.modelsQuery = new GetModelListPaginatedQuery({
            companyId: 0,
            manufacturerId: 0,
            keywords: "",
            pageNo: 1,
            pageSize: 20,
            sort: this.modelsSorter.currentSort,
        });
        this.modelsData = new PaginatedEnumerableOfModel();
    }
    created() {
        this.companyId = parseInt(this.$route.params.companyId) || 0;
        this.manufacturerId = parseInt(this.$route.params.id) || 0;
        const manufacturerTypeIdParam = this.$route.query.manufacturerTypeId;
        if (manufacturerTypeIdParam) {
            this.preselectedManufacturerTypeId = parseInt(manufacturerTypeIdParam);
        }
        this.getLookups();
        this.get();
    }
    ;
    get() {
        if (this.isNewManufacturer) {
            let manufacturer = new ManufacturerModel();
            manufacturer.init({});
            if (this.preselectedManufacturerTypeId) {
                manufacturer.manufacturerTypeId = this.preselectedManufacturerTypeId;
            }
            this.map(manufacturer);
            this.setValues({
                name: this.manufacturer.manufacturerName,
                manufacturerType: this.manufacturerType
            });
            this.loaded = true;
            return;
        }
        this.working = true;
        manufacturersClient
            .get(this.manufacturerId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.loaded = true;
            this.map(response);
            this.setValues({
                name: this.manufacturer.manufacturerName,
                manufacturerType: this.manufacturerType
            });
            this.searchModels();
            this.getCompanyCurrency();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getLookups() {
        this.manufacturerTypes = [
            { value: ManufacturerTypeEnum.ChargerUPS, text: "Charger/UPS" },
            { value: ManufacturerTypeEnum.Battery, text: "Battery" }
        ];
        lookupsClient
            .getComponentTypes()
            .then(response => {
            this.componentTypes = response || [];
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getCompanyCurrency() {
        if (!this.companyId || !this.isBatteryManufacturer)
            return;
        companiesClient
            .get(this.companyId)
            .then(response => {
            if (response && response.currencyCode) {
                this.currencyCode = response.currencyCode;
            }
        })
            .catch(ex => {
            // Silently fail - currency is optional
            console.warn('Could not fetch company currency', ex);
        });
    }
    ;
    map(manufacturer) {
        this.manufacturer = manufacturer;
        this.manufacturer.companyId = this.companyId;
    }
    ;
    save() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            let promise = () => {
                if (this.isNewManufacturer) {
                    return manufacturersClient.create({
                        companyId: this.manufacturer.companyId,
                        manufacturerName: this.manufacturer.manufacturerName,
                        manufacturerTypeId: this.manufacturer.manufacturerTypeId
                    });
                }
                else {
                    return manufacturersClient.update(this.manufacturer.manufacturerId, this.manufacturer);
                }
            };
            promise()
                .then(response => {
                this.manufacturerId = response;
                Notifier.onOk();
                this.get();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all details.");
        });
        handleSubmitAction();
    }
    ;
    deleteManufacturer() {
        if (this.working || this.isNewManufacturer)
            return;
        this.$confirmModal.show("Are you sure that you want to delete this manufacturer?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            manufacturersClient
                .delete(this.manufacturer.manufacturerId, false)
                .then(() => {
                Notifier.onOk(`Manufacturer ${this.manufacturer.manufacturerName} has been successfully deleted.`);
                this.goBack();
                this.working = false;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    var _a;
                    let errorMessage = "";
                    try {
                        const errorObj = typeof ex.response === 'string' ? JSON.parse(ex.response) : ex.response;
                        errorMessage = (errorObj === null || errorObj === void 0 ? void 0 : errorObj.title) || (errorObj === null || errorObj === void 0 ? void 0 : errorObj.message) || ex.message || "";
                    }
                    catch (_b) {
                        errorMessage = ex.message || "";
                    }
                    if ((_a = errorMessage.title) === null || _a === void 0 ? void 0 : _a.includes("model(s) associated")) {
                        this.$confirmModal.show(`${errorMessage.title}\n\nDo you want to delete the manufacturer and all associated models?`, { title: "Confirm Deletion" }).then((confirmForce) => {
                            if (!confirmForce) {
                                this.working = false;
                                return;
                            }
                            manufacturersClient
                                .delete(this.manufacturer.manufacturerId, true)
                                .then(() => {
                                Notifier.onOk(`Manufacturer ${this.manufacturer.manufacturerName} and associated models have been successfully deleted.`);
                                this.goBack();
                            })
                                .catch((ex2) => {
                                HttpHelper.handleResponse(ex2, () => {
                                    Notifier.onServerError(ex2);
                                });
                            })
                                .finally(() => {
                                this.working = false;
                            });
                        }).catch(() => {
                            this.working = false;
                        });
                    }
                    else {
                        Notifier.onServerError(ex);
                        this.working = false;
                    }
                });
            });
        });
    }
    ;
    goBack() {
        this.$router.push({ name: RouteNames.Manufacturers, params: { companyId: this.companyId } });
    }
    ;
    // Models methods
    searchModels() {
        if (this.isNewManufacturer)
            return;
        if (this.workingModels)
            return;
        this.modelsQuery.companyId = this.companyId;
        this.modelsQuery.manufacturerId = this.manufacturerId;
        this.modelsQuery.sort = this.modelsSorter.currentSort;
        this.workingModels = true;
        modelsClient
            .search(this.modelsQuery)
            .then((response) => {
            this.modelsData = new PaginatedEnumerableOfModel();
            if (!response)
                return;
            this.modelsData = response;
            this.modelsQuery.pageNo = this.modelsData.displayedPage;
            this.modelsQuery.pageSize = this.modelsData.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.workingModels = false;
        });
    }
    ;
    editModel(model) {
        this.$router.push({ name: RouteNames.Model, params: { companyId: this.companyId, manufacturerId: this.manufacturerId, id: model.modelId.toString() } });
    }
    ;
    deleteModel(model) {
        if (this.workingModels)
            return;
        this.$confirmModal.show("Are you sure that you want to delete this model?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.workingModels = true;
            modelsClient
                .delete(model.modelId)
                .then(() => {
                var _a;
                this.modelsData.records = (_a = this.modelsData.records) === null || _a === void 0 ? void 0 : _a.filter(m => m.modelId !== model.modelId);
                this.modelsData.recordCount = (this.modelsData.recordCount || 1) - 1;
                Notifier.onOk(`Model ${model.modelName} has been successfully deleted.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.workingModels = false;
            });
        });
    }
    ;
    getComponentTypeName(componentTypeId) {
        if (!componentTypeId)
            return "";
        const componentType = this.componentTypes.find(ct => ct.componentTypeId === componentTypeId);
        return (componentType === null || componentType === void 0 ? void 0 : componentType.componentTypeName) || "";
    }
    get pageTitle() {
        if (this.isNewManufacturer) {
            switch (this.manufacturer.manufacturerTypeId) {
                case ManufacturerTypeEnum.Battery:
                    return "New Battery Manufacturer";
                case ManufacturerTypeEnum.ChargerUPS:
                    return "New UPS/Charger Manufacturer";
                default:
                    return "New Manufacturer";
            }
        }
        return this.manufacturer.manufacturerName;
    }
    get isNewManufacturer() {
        return !this.manufacturerId;
    }
    ;
    get isBatteryManufacturer() {
        return this.manufacturer.manufacturerTypeId === ManufacturerTypeEnum.Battery;
    }
    ;
    get isUpsChargerManufacturer() {
        return this.manufacturer.manufacturerTypeId === ManufacturerTypeEnum.ChargerUPS;
    }
    ;
    get manufacturerType() {
        return this.manufacturerTypes.filter(item => {
            return item.value == this.manufacturer.manufacturerTypeId;
        })[0] || null;
    }
    ;
    set manufacturerType(item) {
        this.setFieldValue("manufacturerType", item);
        if (!this.manufacturer)
            return;
        this.manufacturer.manufacturerTypeId = item.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get noModelsData() {
        return !this.workingModels && (!this.modelsData || !this.modelsData.records || !this.modelsData.records.length);
    }
    ;
    get getPriceTitle() {
        return this.currencyCode ? `Price (${this.currencyCode})` : "Price";
    }
};
__decorate([
    Watch("modelsQuery.pageNo"),
    Watch("modelsSorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturerVue.prototype, "searchModels", null);
ManufacturerVue = __decorate([
    Component({
        name: "ManufacturerVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setFieldValue, setValues } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                    manufacturerType: yup.object().listOptionRequired(),
                }),
            });
            const nameVal = defineInputBinds('name');
            const manufacturerTypeVal = defineComponentBinds('manufacturerType');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                setValues,
                nameVal,
                manufacturerTypeVal
            };
        }
    })
], ManufacturerVue);
export default ManufacturerVue;
